<template>
  <div class="container my-4">
    <vue-headful
      :title="
        `ค้นหาปืน ${
          typeof search != 'undefined' ? search : 'ที่ด้นหาพบ'
        } | Thong Firearms ปืนธง`
      "
      :description="
        `ผลการค้นหาปืน ${typeof search != 'undefined' ? search : 'ที่ด้นหาพบ'}`
      "
      :keywords="
        `${
          typeof search != 'undefined' ? search : 'ที่ด้นหาพบ'
        }, Thong Firearms, ปืนธง, ค้นหาปืน`
      "
      image="https://thongarms.com/dist/logo.png"
      :lang="`th`"
    />
    <h1 class="mb-3">Search Results: {{ search }}</h1>
    <!-- <input type="text" class="mb-3 form-control" v-model="search" placeholder="Search Arms" /> -->
    <div class="grid-container">
      <div class="row w-100 mb-3">
        พบข้อมูลทั้งหมด
        {{ filtheredArms.length + filtheredWelfares.length }} รายการ
      </div>
      <div
        class="spinner-grow text-danger"
        role="status"
        v-if="!arms.length || !welfares.length"
      >
        <span class="sr-only">Loading...</span>
      </div>
      <div class="row w-100 mh-20">
        <div
          v-for="arm in filtheredArms"
          :key="arm.id"
          class="col-12 col-sm-6 col-md-6 col-lg-3 mb-3 mb-sm-4 wow fadeIn"
        >
          <div class="item">
            <div class="img-product max-width d-flex align-items-center">
              <img
                v-bind:src="'/src/assets/product/' + arm.img"
                :alt="`ปืนร้านปืนธง ${arm.name}`"
              />
            </div>
            <div id="product-detail" class="mt-3">
              <h5 :title="arm.name">{{ arm.name }}</h5>
              <p class="color-70">{{ arm.detail | snippet }}</p>
            </div>
            <div id="read-more" class="text-center">
              <router-link v-bind:to="/product/ + arm.id" class="btn"
                >รายละเอียด</router-link
              >
            </div>
          </div>
        </div>
        <!-- <div
          v-for="welfare in filtheredWelfares"
          :key="welfare.id"
          class="col-12 col-sm-6 col-md-6 col-lg-3 mb-3 mb-sm-4 wow fadeIn"
        >
          <div class="item">
            <div class="img-product max-width d-flex align-items-center">
              <img
                v-bind:src="'/src/assets/product/' + welfare.img"
                :alt="`ปืนสวัสดิการ, ปืนสั้นสวัสดิการ ${welfare.name}`"
                title="ปืนสั้นสวัสดิการกรมการปกครอง"
              />
            </div>
            <div id="product-detail" class="mt-3">
              <h5 :title="welfare.name">{{ welfare.name }}</h5>
              <b-overlay
                :show="welfare.inStock == 0"
                class="d-inline-block width-100"
                bg-color="white"
                opacity="0.8"
                blur="10px"
              >
                <p class="color-70">{{ welfare.detail | snippet }}</p>
                <template v-slot:overlay>
                  <div class="text-center">
                    <h6 class="text-danger">OUT OF STOCK</h6>
                  </div>
                </template>
              </b-overlay>
            </div>
            <div id="read-more" class="text-center">
              <router-link v-bind:to="/welfare/ + welfare.id" class="btn"
                >รายละเอียด</router-link
              >
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../config_db";
export default {
  components: {
    name: "Search"
  },
  firebase() {
    return {
      arms: db.ref("product"),
      welfares: db.ref("welfare")
    };
  },
  data() {
    return {
      arms: [],
      welfares: [],
      search: this.$route.params.value ? this.$route.params.value : " "
    };
  },
  computed: {
    filtheredArms: function() {
      const searchName = new RegExp(this.search, "i");
      const searchDetail = new RegExp(this.search, "i");
      // const safety = new RegExp(this.search, "i");
      // const barrel = new RegExp(this.search, "i");
      // const sights = new RegExp(this.search, "i");
      // const trigger = new RegExp(this.search, "i");
      return this.arms.filter(arm => {
        return (
          (arm.name.match(searchName) ||
            // arm.safety.match(safety) ||
            // arm.barrel.match(barrel) ||
            // arm.sights.match(sights) ||
            // arm.trigger.match(trigger) ||
            arm.detail.match(searchDetail)) &&
          arm.show != false &&
          arm.show != "FALSE"
        );
      });
    },
    filtheredWelfares: function() {
      const searchName = new RegExp(this.search, "i");
      let searchDetail = new RegExp(
        this.search.replaceAll("ปืนสวัสดิการ", "ปืนสั้นสวัสดิการ"),
        "i"
      );
      // const safety = new RegExp(this.search, "i");
      // const barrel = new RegExp(this.search, "i");
      // const sights = new RegExp(this.search, "i");
      // const trigger = new RegExp(this.search, "i");

      return this.welfares.filter(welfare => {
        return (
          (welfare.name.match(searchName) ||
            // welfare.safety.match(safety) ||
            // welfare.barrel.match(barrel) ||
            // welfare.sights.match(sights) ||
            // welfare.trigger.match(trigger) ||
            welfare.detail.match(searchDetail)) &&
          welfare.show != false &&
          welfare.show != "FALSE"
        );
      });
    }
  }
};
</script>

<style scoped>
.mh-20 {
  min-height: 20vh;
}
</style>



// WEBPACK FOOTER //
// src/component/Search.vue